<div
  class="sidenav-item"
  [class.active]="isParentHighlighted()"
  [routerLink]="routerLink()"
  (click)="onParentActivate($event)"
>
  <fa-icon [icon]="icon()"></fa-icon>
  <p>{{ labelKey() | transloco }}</p>
  @if (!collapsed() && children().length > 0) {
    <span
      class="sidenav-group-toggle"
      [class.expanded]="expanded()"
      aria-hidden="true"
    >
      <fa-icon [icon]="chevron"></fa-icon>
    </span>
  }
</div>
@if (children().length > 0) {
  <div
    class="sidenav-sub-wrap"
    [class.open]="expanded()"
    [id]="panelId"
  >
    <ul class="sidenav-sub" [attr.aria-label]="labelKey() | transloco">
      @for (child of children(); track child.fragment ?? child.labelKey) {
        <li>
          <a
            class="sidenav-sub-item"
            [class.active]="activeFragment() === child.fragment"
            [routerLink]="childLink(child)"
            [fragment]="child.fragment"
            (click)="onChildActivate(child, $event)"
          >
            {{ child.labelKey | transloco }}
          </a>
        </li>
      }
    </ul>
  </div>
}
